var render, staticRenderFns
import script from "./TableColumn.vue?vue&type=script&lang=js"
export * from "./TableColumn.vue?vue&type=script&lang=js"
import style0 from "./TableColumn.vue?vue&type=style&index=0&id=738035bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports